// =============================================================================
// ShippingSettingsTab
// =============================================================================
// Hosts shipping-related platform settings. Currently exposes the Shopify
// fulfillment defaults; additional shipping providers (USPS/UPS credentials,
// label printing integrations etc.) will slot in as sibling panels here.
// =============================================================================

import { ShippingZonesPanel } from './ShippingZonesPanel';
import { ShopifyFulfillmentPanel } from './ShopifyFulfillmentPanel';

export function ShippingSettingsTab() {
  return (
    <div className="space-y-6">
      <ShippingZonesPanel />
      <ShopifyFulfillmentPanel />
    </div>
  );
}
